import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

// PrimeNG modules
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { InputTextModule } from 'primeng/inputtext';
import { MessagesModule } from 'primeng/messages';
import { PasswordModule } from 'primeng/password';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { SkeletonModule } from 'primeng/skeleton';
import { ToastModule } from 'primeng/toast';
import { TooltipModule } from 'primeng/tooltip';

// Components
import { AuthComponent } from './components/auth/auth.component';
import { PasswordResetModalComponent } from './components/password-reset-modal/password-reset-modal.component';
import { UserLoginComponent } from './components/user-login/user-login.component';
import { UserLoginFormComponent } from './components/user-login-form/user-login-form.component';
import { AppSelectorComponent } from './components/app-selector/app-selector.component';
import { AppCardComponent } from './components/app-selector/app-card/app-card.component';

@NgModule({
  declarations: [
    AuthComponent,
    PasswordResetModalComponent,
    UserLoginComponent,
    UserLoginFormComponent,
    AppSelectorComponent,
    AppCardComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    // PrimeNG
    ButtonModule,
    CardModule,
    CheckboxModule,
    DialogModule,
    DividerModule,
    InputTextModule,
    MessagesModule,
    PasswordModule,
    ProgressBarModule,
    ProgressSpinnerModule,
    SkeletonModule,
    ToastModule,
    TooltipModule,
  ],
  exports: [
    AuthComponent,
    UserLoginComponent,
  ],
})
export class UserModule {}
